import { persistCombineReducers, createTransform } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import user from './user';

// A request cannot outlive the page that sent it. Saved as 'requested' (the
// page was closed or reloaded mid-request), these statuses would keep the
// launch buttons loading forever, since nothing will ever answer.
const LAUNCH_REQUEST_STATUSES = ['activateCitySpotsStatus', 'sendLaunchEmailsStatus'];

const settleInterruptedLaunchRequests = createTransform(
  null,
  (saved) => LAUNCH_REQUEST_STATUSES.reduce(
    (state, key) => (state[key] === 'requested' ? { ...state, [key]: '' } : state),
    saved,
  ),
  { whitelist: ['user'] },
);

const config = {
//   blacklist: [
//     'app',
//     'network',
//     'notifications',
//     'toast',
//   ],
  key: 'primary',
  storage,
  transforms: [settleInterruptedLaunchRequests],
};

const reducers = persistCombineReducers(config, {
  user,
});

export default reducers;
